export const blog = [
  {
    basic: {
      path: "7th-monthly-dec",
      title: "十二月 - 撥開求職迷霧",
      date: "Dec 6, 2022",
      banner: "7th-dec-banner.jpg",
      square: "7th-dec-square.jpg",
      tag: "現今的職業類別更加多元化，所就讀的科系往往不一定能對應到某個特定的工作，雖然這樣發達的社會讓我們擁有更多的選擇權，但在剛進入社會，缺乏「非做甚麼不可」的信念之下，過多的選項反而讓人無所適從...",
      type: "monthly",
    },
    section: [
      {
        title: "《議題概述》",
        content: [
          "現今的職業類別更加多元化，所就讀的科系往往不一定能對應到某個特定的工作，雖然這樣發達的社會讓我們擁有更多的選擇權，但在剛進入社會，缺乏「非做甚麼不可」的信念之下，過多的選項反而讓人無所適從，難以確定未來的志向。然而同時，我們也面對著社會眼光的審視，最常聽見的一句話便是：「單靠興趣是無法填飽肚子的。」雖然現在有越來越多人不認同選擇高薪、穩定、讓人有面子的職業，才是通向人生勝利組的唯一道路這樣的說法，然而我們真的能做到擺脫世俗的眼光嗎？",
          "雖然因著快速進步的科技，人類未來的工作將極有可能被機器人或AI取代，然而與此同時也有許多新興工作正在崛起，正如將網路直播作為正職對十年前的人們來說簡直是天方夜譚，未來也必定會出現許多現階段難以想像的職業，如何在這個快速變遷的世界中走出自己所認可的道路，做出多年後回想起來仍能不感到後悔的選擇，始終是個難題。",
          "接下來的兩篇文章會分別介紹國家兩廳院劉怡汝藝術總監在人生早期，面對抉擇人生道路的迷茫之下，如何調適自己的心態，最終找到自己真正熱衷的領域，以及一些人生小建議。",
        ],
      },
      {
        title: "《調適自身》",
        content: [
          "劉怡汝總監坦言，當時讀完碩士回國時，在媒體產業的就業情況不如自己預期，因此時常感嘆自己的懷才不遇。",
          "進入職場初期，她曾在公關公司工作過一段時間，儘管頭銜再怎麼好聽，她卻遲遲感受不到自己對這份工作的熱忱，同時受阻於外界審視的目光與對未來的擔憂，一直猶豫著不敢辭職。直到最後，她決定放下自己對外界眼光的執著，不再追求光鮮亮麗的標籤，讓自己從緊繃的狀態中解放出來。",
          "「當你一旦放鬆下來之後，機會就找上門來了。」",
          "可能是當時處在過於緊繃的狀態，導致眼界變得狹隘，看不見機會；抑或是她當時自身過於急切和焦慮，讓人敬而遠之。因此當她一放鬆下來時，瞬間就看見了很多機會，甚至主動請求她的協助。",
          "她說這些早年迷茫雖然痛苦，但讓她確實明白自己的興趣在何方，正如英國詩人約翰．米爾頓在《論出版自由》一書曾說：「人要透過惡才能知善。」，劉怡汝總監也透過了從事各種各樣的工作，將它們作為對照組，找出了自已真正有興趣的領域，因此她也建議不要過於排斥迷茫與困頓，因為總會迎來撥雲見日的一天。",
        ],
      },
      {
        title: "《人生小建議》",
        content: [
          "過往的多元經歷成為劉怡汝總監在兩廳院工作時的重要養分，包含第一份在打擊樂團打工時遇見的貴人引領她進入兩廳院、以前工作時主管的處事方式直到現在都會被她拿出來反覆咀嚼，思考是否能將這些方式應用在現在所遇到的困難上。",
          "她也引用了風潮音樂的創辦人楊錦聰的思維模式：「腦子中像是有一個巨大的櫃子，過往的經驗都會被保存在櫃子裡，有朝一日需要用的時候，就把櫃子裡以前的經驗拿出來審視，看看是否能派上用場。如果櫃子中保存的經驗越多，未來面對問題時也會有更多可能的解法。」",
          "例如在大學時期累積的啟明學校活動協助經驗，促使現在的她積極推動讓國家兩廳院成為一個對身障者更加友善的環境，劉怡汝總監致力於讓劇場對每個人來說，不再是一個遙不可及的存在，而是一個能讓更多人欣賞、享受其中的藝術，因此她在硬體設施方面規劃了更多輪椅席、性別友善廁所，並在男廁中放置尿布台，此外，總監在國家兩廳院數位轉型的推動上也不遺餘力，推出OPENTIX數位售票系統，在此系統中不只販售大部分台灣藝文活動的票券，也販售一些在兩廳院演出的現場轉播，讓欣賞藝術這件事能跨越時空和地理上的障礙。",
        ],
      },
    ],
    video: null,
  },
  {
    basic: {
      path: "7th-monthly-nov",
      title: "十一月 - 克服挫折的復原力",
      date: "Nov 1, 2022",
      banner: "7th-nov-banner.jpg",
      square: "7th-nov-square.jpg",
      tag: "對你來說，什麼是挫折？什麼事情會讓你感到壓力或產生負面情緒？從錯過公車等生活小事，到人際關係/學業表現等長期壓力，還有天災人禍、家庭變故等負面事件，都可能被視為挫折...",
      type: "monthly",
    },
    section: [
      {
        title: "《議題概述》",
        content: [
          "對你來說，什麼是挫折？什麼事情會讓你感到壓力或產生負面情緒？從錯過公車等生活小事，到人際關係/學業表現等長期壓力，還有天災人禍、家庭變故等負面事件，都可能被視為挫折。但是在面對它們時，有些人花了很長的時間都無法恢復，有些人卻能夠快速適應這些變化，找到應對壓力與挫折的方法，並回復到原本的狀態。為什麼會有這樣的差異呢？答案就在於「心理韌性」(Resilience)。",
          "根據美國心理學會 (American Psychological Association) 的定義，心理韌性為一個人在面對逆境及生活中的壓力與挫折時，能夠適應良好並有效調適自己，從負面事件中「觸底反彈」(bounce back) 的能力。但這並不是固定不變的特質，任何人都能透過思考的改變來培養這項能力，幫助我們面對突如其來的挫折或壓力時，得以一步步走出逆境。",
          "而心理韌性所相對應的大腦機制，也是心理學家及神經科學家感興趣的研究主題。有研究發現，大腦中負責掌管高階認知功能的前額葉皮質 (prefrontal cortex) 及和情緒反應相關的杏仁核 (amygdala) 兩者之間的神經連結強度，決定了一個人在經歷會產生負面情緒的事件時，其調適心情的速度。若前額葉皮質與杏仁核間的連結增加，則杏仁核會受前額葉皮質的活化影響而降低其對負面情緒的反應，讓人比較不受因挫折帶來的起伏心情影響。",
          "在人生中的每個階段都可能會遭遇壓力及挫折。該如何察覺到這些壓力源並進行自我調適呢？我們將邀請有輔導大學生經驗的社工師，談談大學生常見的壓力來源，以及面對壓力的因應策略和心理狀態調適技巧。",
        ],
      },
      {
        title: "《訪談與調查》",
        content: [
          "大學階段，或許尚未從青少年時期的迷惘中找尋出自己想要走的路，但卻又得逐漸成為承擔責任的大人。處於這段過渡時期的大學生，常見的挫折及壓力來源如學業、人際、社會期許等，都是可能影響心理狀態的變因。",
          "我們透過問卷設計，想了解台大學生對自身心理調適能力的認知，以及最容易感受到壓力的事件。同時，我們也邀請了台大心輔中心的顧晉豪社工師分享此過渡時期對心理狀態的影響和大學生常見的壓力源。",
          "##處在大學生這個從青少年到成人的過渡時期中，心理狀態最容易被哪些事物所影響?",
          "進入大學之前，我們所處的環境都是充滿秩序的－有人告訴你什麼時候該做什麼事情，能夠自我決定的機會較少。然而在大學中，更多的是「學習選擇」，如修課規劃及安排課餘活動等。我們離開原本習慣的框架，擁有更多自由，卻也容易迷失在其中，若無法調適對於生活的不確定性，則可能產生不適應，造成壓力感上升，甚至因此導致憂鬱、焦慮等負面情緒。",
          "##大學生常見的壓力源?",
          "學校適應：對上課方式、同學及大學環境的適應問題，常是造成心理壓力的來源，而其持續時間有長有短，並非只有大一新生才會面臨。",
          "學業議題：對於不同課堂要求的適應及學業壓力的調適。另外多數學生對自己的自我要求高，當發現自己不再名列前茅時，就可能產生焦慮感。",
          "生涯規劃：許多人上了大學之後，會發現原有目標和現實的差異，例如所讀的系並不適合自己，但此時並非每個人都能順利找到新方向，因此常會感到迷惘且產生壓力。",
          "感情問題：大學生除了和他人的人際關係之外，也常面臨到自我認同的問題，從而影響到與他人的相處。",
          "在我們針對台大學生所做的心理調適能力問卷中，有五成的受試者對自己的人生感到迷惘，而有七成的人則因為與同儕的學業競爭而感到焦慮，顯示出這些議題的確是不少大學生共有的壓力源。接下來訪談的第二部分，我們將進一步探討面對壓力時，如何增加與調適心理韌性。",
        ],
      },
      {
        title: "《探討與反思》",
        content: [
          "充滿不確定性的人生、同儕競爭壓力，加上日常生活中無法預料的事件，生活在這個世代的大學生們面臨了不少可能導致挫折感及負面情緒上升的挑戰。因此，建立良好的心理韌性，可以降低壓力所帶來的衝擊，並讓我們保持穩定的心理狀態。而顧晉豪社工師也分享了心理調適的小技巧。",
          "##面對挫折時，調適心理狀態、增加心理韌性的三步驟",
          "1. 自我覺察：發現自己面臨到挫折，影響到原本的生活步調，並產生情緒上或生理上的改變的時候，即是自我覺察的表現。例如：熬夜導致隔日精神不佳而無法專注聽課時，對自己的表現感到沮喪。",
          "2. 自我控制：在覺察到挫折後所做出的改變，例如尋求外界幫助、改變自己的情緒和行為等，減低挫折對自身心理狀態的影響。例如：發現熬夜會影響第二天的精神後，告訴自己要在幾點前睡。",
          "3. 自我效能：當發現自己在自我控制中所做的調整能夠得到比較好的結果時，對於自身能力的信心也會增加，也就是自我效能感(self-efficacy)的提升。例如：早睡後隔天上課的精神變好，解決了造成挫折的問題。",
          "此外，心理學家James Gross提出的認知再評估(cognitive reappraisal)，也能夠幫助我們減低挫折所帶來的影響：當面臨壓力事件時，個體透過調整對於該事件的認知，以減少負面的感受。這樣的歷程就是俗稱的「轉念」，但並不只是單純的想法改變，而是去探討壓力源的不同面向，找出自己可以調整的地方。而自身的認知及情緒狀態，正是我們能夠改變的部分。",
          "雖然大學階段面臨種種無序，然而無序未必全然是壞事，透過心理韌性的培養，未來的我們仍有無限可能！",
        ],
      },
    ],
    video: null,
  },
  {
    basic: {
      path: "6th-tedview-entertainment",
      title: "比起做自己，不如去追求自己喜歡的東西",
      date: "Apr 24, 2022",
      banner: "6th-entertainment-banner.jpg",
      square: "6th-entertainment-square.jpg",
      tag: "傍晚六點，我們來到妮妃雅位在士林的工作室，電梯門打開後，迎接我們的是害羞、帶點靦腆的 Leo，門口擺放著的鳳冠似乎閃耀著他成為妮妃雅後在臺上恣意綻放的樣子...",
      type: "view",
    },
    section: [
      {
        title: "",
        content: [
          "傍晚六點，我們來到妮妃雅位在士林的工作室，電梯門打開後，迎接我們的是害羞、帶點靦腆的 Leo，門口擺放著的鳳冠似乎閃耀著他成為妮妃雅後在臺上恣意綻放的樣子。",
        ],
      },
      {
        title: "踏入變裝領域的初心",
        content: [
          "對我來說，妮妃雅這個扮相就像芭比，打扮她、想盡辦法讓自己變漂亮是使我快樂的。這種「對美的追求」以及「美在我身上的體現」驅動我踏入並從此投身於皇后這個領域中，舉例來說，擁有一件漂亮的衣服後，並不是每個人都能穿出漂亮的樣子，有些人的造型是衣穿人，衣服的結構、氣勢等遠勝於穿衣者本身。",
          "然而，我自己的所有衣服都是自製且為自己而做，而不是為他人，因此我更願意去燃燒自己的生命，甚至是廢寢忘食地只為了完成一套造型，也就是美的產物。",
          "當你知道自己想達成的樣子，就能帶出更整體性的美感",
          "另外，因為自己會做衣服的原因，我對身形比例這件事更敏銳。變裝就是從男生變女生，要將一些比較男性化的身體部位變成女生，而身兼自己造型師的優勢便是，更好調整自己的身形比例，除了一般大家熟知的 Tuck (為了造型所需，將陰莖往會陰處貼平，使胯下盡可能平坦類似女性的陰部)，其實肩寬、腰身等各個部位的細節都是缺一不可的。",
          "剛提到造型這件事，每位皇后都是自己的造型師，而我在髮妝之外多了服飾這個專業，這迫使我在幫自己做衣服時會更吹毛求疵地注意細節 (笑)，像是一件馬甲可以多加一些東西，讓它變得更精緻，別人可能覺得差不多的程度，但因為是幫自己做，所以會追求更完美的樣子。",
        ],
      },
      {
        title: "一路走來最喜歡的造型",
        content: [
          "每一件都是寶貝 (笑)，但如果真要挑一件，我會選最近新完工的紫色妖姬 (戲曲女王…) 鳳冠。其他之前做的頭飾、衣服等等，如今回去看都會有想改或覺得能更好的地方，但這件不會。為了它，我大概可以說是燃燒生命、突破極限了吧，照過去的經驗來看這套至少需要兩三個月，但我將它壓縮到一個月內完工，每天早上九點半起床後喝一口水就是進工作室縫縫縫，連續兩星期睡四個小時。",
          "當你為一件事情付出很多時，你真的會感受到自己全身心投入，眼中大概只剩下那個縫線和針，會非常專心且心無旁鶩的做這件事。我真的很喜歡這套，總覺得有把某部分的靈魂放進去，是個灌注靈魂的作品，可能是因為有些壽元放進去的緣故吧 (大笑)。",
          "(追問這麼拚命的原因) 是因為接到合作案，很多人都問我為甚麼對這個案子要那麼拼命，但我自己認為這是個難得的機會，很少有變裝皇后和戲曲中心的合作可能，於是便逼自己衝一波，就把它做下去。",
          "至於憑藉的東西嗎？大概就是硬著做，再加上熱情、意志力以及對美的追求 (所以壽命才會跑進去)。我以前不會很大膽講出追求美，但做完鳳冠後，真心覺得沒有追求是沒有辦法兩星期不睡覺的。燃燒生命就是一種藝術，你當下會覺得做完作品最重要，即便死了也沒差、很值得。",
        ],
      },
      {
        title:
          "戲曲中心的合作之外，從過去的作品了解到你很擅長玩轉東方元素，很好奇這背後的原因是？",
        content: [
          "我喜歡帶有東方元素的東西，這在國外做不了，而身在這個環境，更了解這個文化之外，也能更直接地去接觸它。不過我的狀況比較特殊一點，我不是在傳統台灣教育體制下成長的人，有點像隔了一層膜的感覺吧，我生在這個環境，但又對它充滿好奇、熱情，如果你從小生長在一個環境，會覺得沒什麼新奇，就像倫敦人對倫敦就沒感覺，但觀光客則往往會有。",
          "坦白講，我對戲曲的一些東西還是相當陌生的，我一直認為自己應該跟這些東西成長，但現實情況又沒有，所以我必須用自己的方式去接觸這個文化。一般來說，廟會、臉譜都代表相對陽剛的概念，藉由我自己是生理男性，變裝成女生去融合這些陽剛的東西，這種模糊傳統界線能帶來更多新奇跟可能性。",
          "我喜歡激烈一點、強烈一點，多種概念融合在一起的感覺，像是剛提到的鳳冠那套，融合古代的武打元素，但又帶有那種青衣女子的柔軟感覺，有種陰陽結合、融和的概念在裡裏頭。",
        ],
      },
      {
        title: "Nymphia 與 Leo 兩個角色之間的對話、交流及分野",
        content: [
          "我並沒有覺得這兩者在對話，他們是不同的角色，周圍朋友都會覺得兩者散發出來的感覺和能量都是不一樣的，具體來說，妮妃雅是個臉臭之餘還可以跟人社交的角色，但現在這個沒有化妝的 Leo 就幾乎不能。",
          "除了別人的感受，其實我自己也能感受到變裝前後的那種差異，兩個角色沒有互相溝通，但互相知道彼此存在。你整個人的狀態會因服裝妝容而改變，那是個很抽象、難以言喻的感覺，有點像給你一層盔甲、沒有人認出原本的你，所以就可以高昂地去做自己想做的事，戴完假髮、假睫毛，加上服裝和高跟鞋的束縛，就種要上班了、醒來的感覺。",
          "不過也必須說，妮妃雅是個無時無刻不舒服的狀態，戴假髮、睫毛、三四層絲襪，整個感覺就是「我可以下班了嗎？？？」，但現在和你們訪談的我就是舒服、隨便。有些人可能會覺得變裝是種超脫，我是覺得對平常比較壓抑的人來說是一種解放沒錯，但我媽給我的生長環境允許我從小到大做自己，因此我畫完妝不太會有這種大解放的感覺，這對我來說就只是變漂亮的過程。",
          "我會說這兩者有點像容器，有很多不同面向的我，社交、假笑由妮妃雅負責，把這部分的我拿出來裝在妮妃雅的容器中由他展現，有點像人格分裂，有些歸納為男生 (Leo)，另一些則是女生 (妮妃雅)。",
        ],
      },
      {
        title: "外部環境改變所帶來的影響",
        content: [
          "(前陣子有發生變裝皇后不被視為表演藝術工作者，你怎麼說？) 我覺得那是一種出自不太了解的心態，這畢竟對臺灣來說仍是一個新型態的藝術，我想他們也只是不太了解，畢竟在其他人提醒之後就有所修正，所以並不會覺得他們怎麼樣。",
          "另外很有感的是，最近這個領域越來越蓬勃，可以看到越來越多人有勇氣去做，但老實講台灣最大的問題是太小，空間很小、人也比較少、市場也小，雖然知道這應該是個比例性的問題，但客觀來說若每個國家有 10% 的人喜歡，在美國可能是好幾萬人，在台灣就可能只有少少的一千。不過也必須說，現在和我剛開始做皇后時相比已經成長很多，當初就是一個月有一兩個派對就該偷笑了，但現在每個星期都有秀。",
        ],
      },
      {
        title: "在所有變妝元素或環節中，最喜歡的部分",
        content: [
          "最喜歡卸妝 XD，還有做衣服、準備自己的造型。之所以沒有說表演是因為覺得自己的表演還不夠好，還沒達到自己的要求，表演對我來說有兩種意義，一方面是賺錢，另一方面對我來說則是個成果發表，站上舞台那一刻就是最終的終點，是辛苦做衣服時的目標，是做衣服熬夜的結果，是把自己想要表演或傳遞的東西綻放出來、展現自己的價值所在。",
          "關於這部分我還在尋找，有覺得自己近期的表演狀態是好的，漸漸能達到自己排練時所想像的感覺，表演是將醞釀、用功訓練的東西一次綻放出來的過程，舞台是一個終點，對我來說，是個展現靈魂的地方。",
        ],
      },
      {
        title: "送給迷惘世代的話",
        content: [
          "在舞台上表演時，我想散發出我在舞台上為自己所愛的事物而燃燒的那種感覺，也常常在想，當我在台上為自己而燃燒的同時，台下的你是不是也要思考自己究竟是為什麼而燃燒的。",
          "這是個迷惘的世代，我自己也是很迷惘的一個人，既然是如此何不大家就一起迷惘。很多人都說要做自己，但講出這些話的人真的做得到嗎？對社群世代的我們來說，多數時候這種自我也都是默默學來的，所以說比起做自己，不如說要找到自己喜歡的東西去追求。",
          "加油吧，迷惘其實也沒有不好，但起碼要很漂亮地迷惘，就這個路怎麼走也是要看個人，接納自己在迷惘的狀態，我覺得也不錯。",
        ],
      },
    ],
    video: {
      title: "訪談影片",
      src: "https://www.youtube.com/embed/iNgHRw2dBw4",
    },
  },
  {
    basic: {
      path: "6th-tedview-geopolitics",
      title: "地緣，無從逃避的連結 – 專訪陳世民教授",
      date: "Mar 6, 2022",
      banner: "6th-geopolitics-banner.jpg",
      square: "6th-geopolitics-square.jpg",
      tag: "在一個飄著陣陣細雨的寒冷夜晚，我們略顯侷促不安地站在門外。正在猶豫著要不要敲門之際，門突然開了。陳世民教授帶著和藹的笑容，邀請我們進入辦公室。在滿室書籍的圍繞和辦公室外的雨聲下，我們開始了關於國際、關於兩岸的訪談...",
      type: "view",
    },
    section: [
      {
        title: "",
        content: [
          "在一個飄著陣陣細雨的寒冷夜晚，我們略顯侷促不安地站在門外。正在猶豫著要不要敲門之際，門突然開了。陳世民教授帶著和藹的笑容，邀請我們進入辦公室。在滿室書籍的圍繞和辦公室外的雨聲下，我們開始了關於國際、關於兩岸的訪談……",
        ],
      },
      {
        title: "地緣．戰爭．國際互動",
        content: [
          "地緣政治作為牽動國際政治互動的重要因素，在現今許多國際衝突中，都能看到其影響力，烏俄衝突自然也不例外。烏俄衝突的淵源，在蘇聯瓦解時便已種下。對俄羅斯而言，將近三十年來，其所處的地緣政治的環境越來越惡化，尤其近年來烏克蘭為了申請加入北約組織不遺餘力，更是讓俄羅斯的國家安全利益雪上加霜。「烏克蘭其實已經距離莫斯科非常接近了，而在歷史上，烏克蘭長期以來也都是俄羅斯的勢力範圍，」陳世民教授解釋，「所以他（俄羅斯）無法容忍烏克蘭加入北約組織，因為這代表西方國家或美國軍隊，可能可以部署到接近俄羅斯的首都——莫斯科。」",
          "除了烏克蘭，教授也提及許多需要關注的國際衝突，例如中東地區伊斯蘭教不同教派間的分歧；自 2011 年持續至今，尚未看到和平曙光的敘利亞內戰；以及位於東亞的北韓、南海與釣魚台問題等。陳世民教授也特別強調國際衝突引發的人道危機，像是葉門連年的內戰，使得在二次大戰後理應得到控制的霍亂，反而更加失控，當地近百萬的兒童也長期籠罩於飢荒的陰影之下，每年都有超過十萬以上的兒童因此死亡，生命安全深受危害。而在這些令人擔憂的國際議題之外，與我們最切身相關的臺灣，也是一個不容忽視的國際衝突熱點。",
        ],
      },
      {
        title: "臺灣：熱點，還是弱點？",
        content: [
          "臺灣在國際社會中所遭受的困境，是許多臺灣人民所關注的議題。但陳世民教授首先提及的，是美中之間錯綜複雜的關係。「在二十一世紀的國際關係當中，美中之間的互動關係是最重要，也最具代表性的。」教授指出，中國與美國之間的爭端，可視為陸權國家與海權國家之間的相互競逐。中國作為傳統陸權強國，在其經濟實力壯大後，便積極地發展遠洋海軍，試圖擴張在海權方面的影響力。",
          "這樣的舉動，自然讓目前最強大的海權國家——美國，認為自己的地位受到挑戰。面對中國所施加的壓力，美國則是以日本、琉球、臺灣及菲律賓所組成的第一島鏈來應對。如果中國要走出遠洋，就必須要先突破第一島鏈對歐亞大陸的封鎖。「但是，」陳世民教授話鋒一轉，「對中國而言，臺灣可能是在這條第一島鏈裡最脆弱的地方。」",
          "「因為日本、琉球及菲律賓都是美國盟邦，都有跟美國簽訂軍事結盟，但臺灣不是啊。」教授無奈地說道，雙手一攤，「臺灣基本上還是在國際上處於相當孤立的狀態。」因此，對於《經濟學人雜誌》將臺灣視為「全世界最危險的地方」，陳世民教授認為，這樣的評價是有其道理存在的。因為除了臺灣是在美中地緣政治的角力上一個承受很大壓力的熱點之外，教授也相信一旦兩岸發生戰爭，中國不可能不拿下臺灣就退兵。「如果今天中國在這種狀況下就退兵的話，」陳世民教授解釋，「那接下來可能就是臺灣宣布法理獨立了。」",
          "在已抵擋過中國的前提下，西方國家會更有意願承認臺灣獨立，而這樣的情況，極有可能導致中國內部的權力鬥爭。回顧中國過去習近平扳倒的政治人物，薄熙來、周永康等人，現在都仍在監獄服刑。「對於像習近平這樣的一個獨裁者而言，他寧可失去他的權力，然後可能導致自己下場很慘，」教授向我們提問，「或者，他會堅持打臺灣，打到拿下來為止？」",
        ],
      },
      {
        title: "從孤立中突圍",
        content: [
          "近年來，中國積極發展的一帶一路計畫發展不如預期，而這樣的轉折與各國的保留心態有不小的關係。過去，中國期望藉由推展一帶一路的機會。順勢擴大其對全球政治的影響力。因此，一帶一路如果推展成功，臺灣可能將遭遇更嚴重的國際孤立。然而，對於中國所描繪的，幫助發展中國家發展基礎建設、共同繁榮發展的願景，有些國家則是抱持著懷疑的態度。",
          "「很多國家逐漸看到的，可能是債務陷阱。」陳世民教授接著以斯里蘭卡作為例子，敘述斯里蘭卡現在所面臨的困境，「由於現在國家承受中國很大的債務，導致它有很多國家的資產或者土地，可能會因此受到中國控制。」債務的出現，是因為中國進行基礎建設時，仍採用中國工人。中國的「援助」，不但沒有解決當地的失業率問題，更導致受到援助的國家背負沉重債務。",
          "種種問題，使得越來越多的國家，如立陶宛等，決定斬斷和中國的合作，而這也為臺灣提供了在國際社會進一步發展的機會。「當他們了解到中國的一帶一路對他們國家反而並不是好事的時候，他會更願意去改變他的兩岸政策，提升跟我們臺灣的關係。」教授笑道。",
        ],
      },
      {
        title: "檢討的謬誤 V.S. 邏輯的錯置",
        content: [
          "##「台海的和平穩定，目前最大的問題還是在於中國，在於習近平很明顯地一直使用軍事手段。」陳世民教授放下比畫的雙手，神情嚴肅，「不是臺灣做錯什麼事情，我不認為我們需要多去檢討自己。」",
          "對教授而言，不論是中國將軍機繞台的原因歸咎於臺灣內部追求獨立，還是部分臺灣人民認為台海現今的不穩定是因為臺灣不願意接受九二共識等政治協商，都是不合理的。「就像我們小孩子打架一樣，誰先動手，誰就是錯；誰先使用武力，誰就是錯的。」陳世民教授接著再度強調：「現在是中國在使用武力，不是臺灣在使用武力在威脅中國。所以不能因為臺灣不完全照中國所期盼的方向去走，或接受中國所要求的東西，就說有理由可以使用武力來威脅我們。這基本上是錯誤的。」",
          "教授同樣指出，中國對待臺灣的方式其實是邏輯上的錯置。「因為中國先使用武力來威脅臺灣，反而使臺灣民心向背，離中國越來越遠，越來越不想跟中國統一，越來越不想當中國人。」雖然在經濟層面，中國自稱已給予臺灣很多讓利，然而，陳世民教授並不認為臺灣民眾會因此對中國的做法產生好感，因為這個很明顯是一種恩威並施的方式。以馬英九八年執政時期為例，當時兩岸的互動最為密切，但弔詭的是，此時反而是支持臺灣獨立占比的高峰。「當明眼人一看就知道這是中國統戰的作為，那臺灣要如何對中國產生信任感？」",
          "那面對中國的施壓，臺灣又該如何應對呢？對於這難解的問題，教授認為關鍵在於中國仍是一個威權共產主義的專制體制。唯有等到中國也變成一個民主自由的國家，兩岸才有機會平心靜氣地思考，並討論兩岸的未來走向。至於臺灣如何應對現在的兩岸問題，則只能回歸基礎，持續與其他共享民主自由價值的國家發展更為密切的合作關係。",
        ],
      },
      {
        title: "日常危機——軍機擾台",
        content: [
          "提到前陣子美國脫口秀節目 Last Week Tonight with John Oliver 中，臺灣人民對中國軍機擾台習以為常的態度，陳世民教授不禁無奈地笑了，「西方媒體記者就覺得很奇怪，怎麼臺灣最關切的話題，居然是王力宏事件，而不是當時一天裡來三四十架軍機繞台。」對於這樣的狀況，教授也坦承這是一個臺灣需要面對的大問題，因為這代表臺灣仍存在社會對立，也就是國家認同的分歧。更進一步來說，可以說是由於不同的政治立場，導致敵我意識的欠缺，甚至對少部分人而言，中國威脅臺灣是合理的，理由是臺灣不希望與中國統一。但陳世民教授仍強調：「臺灣是一個民主國家。在一個自由的國家裡，每個人都有表達自己政治傾向的自由。」",
          "「另一方面，也是臺灣老百姓某種程度的無奈感。」教授解釋，中國軍機擾台已成常態，甚至最近一年幾乎每天都來。但儘管中國已進入臺灣的防空識別區，實際上臺灣也無可奈何。「防空識別區不是領空，只是每個國家所設置的防空識別的區域。」陳世民教授特別為我們釐清。",
          "防空識別區是由國家單方面設置的，但是其他國家並沒有同意彼此防空識別區的訂定標準，領空才是一個國家真正的主權範圍，而中國到目前為止，都尚未侵犯到臺灣的領空。「所以只能說是對臺灣安全的一種騷擾。」提到這點，教授也忍不住皺眉，因為只要沒有侵犯領空，從國際法的角度來看，臺灣確實無計可施。",
        ],
      },
      {
        title: "「勿恃敵之不來，恃吾有以待之。」",
        content: [
          "在訪談的尾聲，陳世民教授提供了幾個可能可以提前了解中國動向的方式。在科技方面，可以透過衛星觀察中國是否有進行軍隊調動，如果大量飛彈、船艦及軍機等調動到台海對岸，就可能是一個徵兆。至於外交上的動向，則可以從美國是否撤僑來觀察。當戰爭或危機爆發時，各國通常會撤離使館人員或僑民。",
          "因此，假設中國攻打臺灣的跡象越來越明顯，美國便會希望在臺灣的僑民能夠撤僑。換句話說，如果美國決定撤僑，代表美國認為事態極為嚴重，也可能表示美國有意使用武力手段來解決問題，例如在 2017 年的北韓核武問題中，美國撤僑與否，即被視為時任美國總統川普是否將以軍事手段處理雙方衝突的其中一項指標。",
          "「勿恃敵之不來，恃吾有以待之。」是陳世民教授對現在臺灣整體兩岸方針，也是對臺灣人民的建議。教授認為，如果中國真的確定要攻打臺灣，會採用突然奇襲的方式，因此也不需要特別去揣測中國攻打臺灣的時間點。「對臺灣而言，當然要隨時做準備」陳世民教授說道，「不要抱著僥倖心態，覺得中國一定不敢打臺灣；也不要抱著逃避的心態，好像中國一定打不贏，所以不能打。」這樣的理念可以套用到所有國家，教授也以這樣的態度，勉勵並期許臺灣人民能在心態上做好準備。",
          "##「面對任何的威脅或者挑戰，我們都可以去應對，這才是最重要的。」",
        ],
      },
    ],
    video: {
      title: "訪談影片",
      src: "https://www.youtube.com/embed/jV8MwGU3R4Q",
    },
  },
  {
    basic: {
      path: "6th-tedview-tech",
      title: "從道路設計看台灣交通",
      date: "Feb 22, 2022",
      banner: "6th-tech-banner.jpg",
      square: "6th-tech-square.jpg",
      tag: "在一個週末的冬日午後，我們與 Charles 暢談台灣交通目前的發展和阻力。 Charles 長期在 Medium 平台上以松山查爾斯為名，耕耘交通工程設計並且發表文章，以一篇「京都四條通人行道拓寬計畫」為人所知。 他信手拈來海內外諸多實際案例，帶給大家在交通工程設計這個重要又如此切身的領域有初步的認識和思考..",
      type: "view",
    },
    section: [
      {
        title: "",
        content: [
          "在一個週末的冬日午後，我們與 Charles 暢談台灣交通目前的發展和阻力。 Charles 長期在 Medium 平台上以松山查爾斯為名，耕耘交通工程設計並且發表文章，以一篇「京都四條通人行道拓寬計畫」為人所知。 他信手拈來海內外諸多實際案例，帶給大家在交通工程設計這個重要又如此切身的領域有初步的認識和思考。",
        ],
      },
      {
        title: "台灣交通工程設計的掙扎與進展",
        content: [
          "根據交通事故死亡率道路事故統計數據表明，台灣在 10 萬人中的死亡人數為 11.49 人，與日本（3.5 人）和荷蘭（3.13 人）形成鮮明對比。 事實上，相較於日本的國土交通省和荷蘭的交通及水管理部 ( Ministerie van Verkeer en Waterstaat V&W ) 皆同時掌管都市計劃和交通體系兩者之間盤根錯節的整合和規劃， Charles 指出台灣的內政部營建署和交通部相對之下較無實質上的緊密合作。除了制度面之外，「台灣的交通工程設計亦有其歷史脈絡，深受 1970 年代美國大公路主義影響」Charles 道出台灣的交通現況是在設計思維上，帶有過往時代思潮的影子，此外，戰後城市的交通建設也多半已經定型。交通和都市計畫部門的缺乏合作和對大公路主義的推崇，皆造成了時下台灣道路有許多定位不明的交通工程設計，灰色地帶的路肩便是一個鮮明的例子。",
          "##「路肩的模糊定位，使得道路設計上，既不安全又沒有效率」",
          "台灣有許多用途不明確的路肩，大家普遍默認路肩是機車的慢車道，然而，「路肩做為一個定義不清楚的空間，各種活動諸如洗車、種菜和停車便容易發生，也變相地成為推動人行道的阻力」Charles 長嘆道，而這也在在說明了機車騎士在台灣的困境。",
          "在台灣的機車駕照考試，多半沒有提供足夠的交通制度和交通設計上的教育，不論是標線或是不同道路的應對方式。根本原因在於，台灣打一開始便沒有架構性的道路設計能有系統地傳遞資訊給機車騎士，例如有無兩段式待轉區、有些機車要在最右側一起左轉、有無摩托車禁行車道等等，「各種制度疊床架屋，道路設計非常凌亂。理想狀況下，摩托車的騎士在馬路上應該要可以清楚知道這條道路會給他什麼樣的資訊」Charles 以自己身為機車騎士的親身經驗列舉了許多道路和規則設計的不一致情況，同時他也指出台灣的交通工程設計存在的盲點，以曾經鬧得沸沸揚揚的機車兩段式待轉為例，儘管兩段式待轉的初衷是要解決汽機車混流，機車卻容易遇到右轉汽車的問題，「但最根本的做法是減少衝突點，機車左轉走內側，追求嚴格的車向分流，例如荷蘭，既無衝突也提升效率。」Charles 強調。",
        ],
      },
      {
        title:
          "「理想的交通工程設計」能降低 Door-to-Door 的門檻 : 交通手段的多樣性與人行道的設置",
        content: [
          "不知道你有沒有過這樣的經驗 ? 每逢通勤尖峰時段或是過年過節返鄉潮，都需要經歷令人感到生無可戀的塞車。或許我們會直覺地認為，解決交通堵塞可以仰賴增加快速道路系統和道路拓寬，誘發更多汽車駕駛人選擇開車做為交通手段；乍看之下公路的供給面能在同樣的時間內承載更多的車輛 ── 然而以台灣這樣人口密集的先天限制下，仍然以汽車為本位嘗試解決塞車問題，令交通的效率陷入一個無解的迴圈。",
          "##「理想的交通工程設計應該以人為本，而不是以汽車為出發點」",
          "Charles 提出以港口起家的城市 : 荷蘭鹿特丹為例子，都市計劃圍繞著公共運具來做規劃，積極地採納寬容性設計，讓民眾能有選擇交通手段的權利，不論是走路、 騎腳踏車、 公車、輕軌、自行開車和搭計程車，每一個交通手段的選擇成本都相去不遠。「不會讓民眾覺得自行開車的成本遠低於其他交通手段，而是透過大眾運輸盡力達到 door-to-door 的可能」Charles 補充。",
          "##「Door-to-Door的概念，最後仍然是靠行人的雙腳。人行道的部署是一個城市的基礎」",
          "宏觀來看，人行道的存在使城市更有活力，交通的角度上也才能有效地保護行人。為何大家看到台中的精明一街覺得舒適整齊 ? 因為有人行道系統，有人行道的狀態下，人們更願意逗留，「一般人認為人行道會影響生意或開車的效率，但其實人行道的設置更會帶來人潮跟錢潮」Charles 打破了一般民眾認為人行道的設置會造成交通更加堵塞的迷思。",
          "在人行道的推動上，不能只是強硬地執行，推廣時要設想眾人的利益，Charles 舉出實際案例佐證 :「例如緊鄰台灣大學一側的新生南路在人行道的推動上並無太大反彈，因為民眾能對學生的安全同情共感」，利用較為彈性且智慧的政策引導方式，人行道亦可在小學附近逐步落實，保障孩童安全。或許建設人行道一開始會讓人認為佔據了行車空間使交通更壅塞，但有人行道時整個城市會更有生機，減緩塞車現象 ( 因為民眾有除了開車之外的選擇 )，也降低搭乘公共運輸的成本 ( 前往搭乘大眾運輸的阻力降低 ) 。",
        ],
      },
      {
        title: "大眾運輸導向的交通工程設計",
        content: [
          "Charles 認為台灣的交通工程設計可以循序漸進，不需執著需要像荷蘭的交通系統般無懈可擊。台灣是都市密集型的社會，相當有利於發展大眾運輸。由此，必須全面思考民眾在搭乘大眾運輸時會遇到的阻力。例如前往搭公車的路上非常不便，班次也少，造成整體公車的運量不高，惡性循環造成班次減少，更加降低民眾搭乘的意願。 以美國為例，單核心的狀態促使車流相當單純 : 開車進城再駛離市中心；然而台灣在住商混合和多核心的狀況下，先天設計上本就比較困難，住商混合並非原罪，但需要更進一步思考交通和社區之間如何做串聯。",
          "舉例來說，新加坡是典型的大眾運輸導向發展 ( Transit-oriented development，簡稱TOD ) 的模式，以捷運為中心點，連接公車站跟商場，並因應頻繁的午後雷陣雨會有遮雨棚，從捷運散發出去，方便行人徒步在住家和捷運站間往返，人行道體系會到重要的交通節點，藉此促進大家使用公共運輸 。反之，社區在道路的設計上是區塊式 ( 街區限制道路作為街區出入口的數量 ) 而非棋盤式 ( 通行無阻，並不封閉特定路口 )，汽車需要多繞路才能抵達捷運站，變相限制了汽車使用的動機。",
          "人行道和公車的設置既省錢又容易部署，公車相較於鐵軌式的交通工具對執政者來說可能相對沒有亮點，但公車可以深入角落，而且路線彈性，解決很多交通的問題的同時，亦能培養市民使用公共運輸的比例，「公車路線部署得多也降低 door- to-door 的門檻，只是配套措施需要完善，因為公車路線資訊的取得成本相對鐵路運輸來得高」Charles 詳細地闡述了公車既相對實惠又機動性高，同時也說明公車相較於有鐵軌的交通運具來說，將會仰賴市民更多的心力熟稔公車路線。",
        ],
      },
      {
        title: "台灣交通的展望與願景",
        content: [
          "交通工程設計的概念旨在透過深思熟慮的道路規劃，減少用路人諸如行人、自行車、機車和汽車等等的可能衝突點。目前台北市以外的人行道系統仍然相對不完善，若能致力於倡議人行道的價值，民眾必能逐漸發現交通工程設計必須以人為本的重要性。以人為本的設計也不僅限於人行道， Z 字型斑馬線 ( 兩段式穿越道路 ) 的的設立也能讓行人減低過馬路時的恐懼和壓力，目前已在彰化縣員林市的兩家醫院前部署；交通部也在今年一月針對道路交通安全精進作為推出 21 項改善措施，囊括行人穿越線退縮、增加庇護島、車道瘦身，讓直行車與待轉車分流等舉措，若能將交通工程設計的思維推及更多的民眾和決策者，相信能避免許多的矛盾和犧牲。",
        ],
      },
    ],
    video: {
      title: "訪談影片",
      src: "https://www.youtube.com/embed/V3Em1vVRbTc",
    },
  },
  {
    basic: {
      path: "6th-tedview-business",
      title: "商業和永續共存的未來",
      date: "Jan 30, 2022",
      banner: "6th-business-banner.jpg",
      square: "6th-business-square.jpg",
      tag: "「原先，企業和 NGO 是對立的組織，彼此不相往來。但現在，想解決眾多的社會、環境問題，他們必須借重彼此的能力，攜手並進」 — 劉世慶教授",
      type: "view",
    },
    section: [
      {
        title: "企業好好賺錢就好，裝什麼善人？",
        content: [
          "##「原先，企業和 NGO 是對立的組織，彼此不相往來。但現在，想解決眾多的社會、環境問題，他們必須借重彼此的能力，攜手並進」 — 劉世慶教授",
          "「永續就是，我們這一代的發展不應該損及後代追求繁榮的權利。不過多數人在既定印象上，只會將其與環境連結，而缺少更宏觀的理解。」教授說道。他表示，永續除了直觀想像中的環境議題，也在逐年發展下，慢慢形成了三本柱：「經濟」、「環境」和「社會」。",
          "就早期經濟學觀點而言，社會中的政府、NGO（非政府之非營利團體）、商業在各司其職、追求自身最大利益就能為社會創造最大化公益。不過教授點出，在實務上，團體間的目標是會相互影響、甚至有所衝突的，舉例而言，商業追求成本最小化，就常與 NGO 想要維持勞動權益的目標有所衝突。",
          "「在企業的影響力越來越大的現代，相對應的利害關係人網絡也就會越發複雜，也就是說，企業做一個決策會影響到的層面也就更多。」他認為，在這樣複雜的關係網絡下，我們是需要企業為了社會和永續發展作出貢獻，否則單靠其他非營利團體是遠遠無法達到目標的。",
          "而商業投入永續，絕不僅僅是多一個做善事的團體而已，反之，隨著企業的加入，帶入的是企業的創意、執行能力和資金，可謂對永續這個領域注入一股活水。",
          "若能打破企業和 NGO 之間的隔閡，轉而結合企業影響力以及 NGO 對於各領域充沛的知識，終將達到教授口中「團體間共同合作、攜手並進」的願景，成為長久發展的一大助益！",
        ],
      },
      {
        title: "攸關未來的責任，可以放心交給企業嗎？",
        content: [
          "##「每一次的消費，都是消費者就自己相信的價值進行投票，希望哪個產品、企業繼續留存。」",
          "近期研究中顯示，商業在人們心中的信任度是逐年下滑、每況愈下。許多人會懷疑，如果把攸關未來存亡的責任交予企業，縱然現在他們看起來很盡責和良善，會不會在哪天又本性流露，放棄原先的計劃以及對社會的承諾？",
          "面對這個問題，教授帶著我們一起回到企業發展 CSR（社會企業責任） 和承擔永續議題的初衷，也就是這些行為對他們有何誘因開始想起。",
          "「因著時代的變遷，利害關係人在產品或服務的追求上也有了很大的變動，股東可能希望他投資的公司更環境友善、而消費者也可能希望自己買的東西能更符合綠色意義。」他說。",
          "「而將職場打造的更友善，也可能吸引到更多人才、同時提升內部的生產力，讓整體擁有更好的經濟價值。」教授也提到了，不只前述看來較為積極的內外部效益，像是能免於受法規管理造成額外成本這樣更直接的因素，也是他們執行的誘因之一。",
          "不過，實際面看來，執行這些計畫也都需要營運成本，在製作出一套良好的計畫後，固然能夠帶來相當效益，但這並非穩賺不賠的生意，那社會、或者是我們又該如何督促、協力使商業持續朝這個方向努力呢？",
          "對於企業來說，每一個決策最終還是需要回到利益相關人以及股東的面向思考，而這大概可以由消費以及投資兩大市場來對企業決策做出影響。「當消費者或投資者，在決策時都會將永續的價值納入考慮，不論出於銷量的考量、或者對資本的需求，對於廠商而言，這樣的現象就會構成持續執行的 Driving Force（驅動力），鼓舞他們繼續做好永續。」",
          "換言之，面對能不能將未來寄託在商業手中這個問題，真正決定答案的其實是在市場中活動的每一位消費和投資者，我們每一次的消費、投資和選擇，都會是決定我們未來世界走向、商業決策的重要關鍵！",
        ],
      },
      {
        title: "讓永續成為商業的對外招牌",
        content: [
          "##「若企業能持續重視永續發展，並且逐漸提升在永續人才上的待遇，搭配著在市場、消費者等方面的驅動力，台灣未來真的能把永續作為對外的一面金字招牌。」",
          "在國際間貿易頻繁的現代，多數人對於各個不同國家的商業都有些鮮明的想像在，像是當我們想到美國，就可能聯想到矽谷象徵的創意無限；或者像想到日本，就可能想到對於細節兢兢業業的工匠精神。",
          "「在過去，台灣的商業醜聞，像是食安危機等，都不只是在台灣有報導，而是在全球流傳，而這也導致國外廠商在尋找合作時，會對於跟台灣廠商合作有著不小的疑慮。」教授說道。",
          "曾有一說，是台灣能嘗試將永續作為商業上對外招牌，這對於商業和國家形象都會有正面效益。對此，劉教授認為，若台灣能有更多企業重視永續概念，並且付諸實現，未來確實有機會實現這一目標，但這些必須從教育做起。",
          "在人才培育的方向上，他提出了「雅典式教育」這樣的概念，意指貫徹全面性的教育理念，不再只專注於單一層面；由原先單純投資、管理能力等單項技能的培養，轉為更加全面的教育學生管理、永續等綜合思考的能力。",
          "「除了商業上的專業知識，也必須對社會議題、環境議題有足夠的認識和背景，才有辦法將議題和營運良好的整合，不再只是獨立的知識。」教授說。",
          "在有了全方面、且具備永續觀念的人才進入管理群之後，才有辦法真正將永續和企業責任正式納入企業的策略之中；當永續真正變成公司營運策略的一部分時，才可能真正實現永續的經營模式；而當永續成為了營運模式之後，才有可能成為台灣的對外招牌。",
        ],
      },
    ],
    video: {
      title: "訪談影片",
      src: "https://www.youtube.com/embed/ArvyuJHoT3M",
    },
  },
  {
    basic: {
      path: "6th-tedview-global",
      title: "想欺負人不需要任何理由",
      date: "Jan 9, 2022",
      banner: "6th-global-banner.jpg",
      square: "6th-global-square.jpg",
      tag: "夜幕低垂，離開台北市的車水馬龍，尋著暖黃的燈光，我們輕推玻璃門，走進蘇予昕心理諮商所。迎面而來的女子，神情堅定地閃著光芒，她是蘇予昕諮商心理師，在她話音落下的一隅，陰影後的曙光悄然浮出...",
      type: "view",
    },
    section: [
      {
        title: "",
        content: [
          "夜幕低垂，離開台北市的車水馬龍，尋著暖黃的燈光，我們輕推玻璃門，走進蘇予昕心理諮商所。迎面而來的女子，神情堅定地閃著光芒，她是蘇予昕諮商心理師，在她話音落下的一隅，陰影後的曙光悄然浮出。",
        ],
      },
      {
        title: "「霸凌」是什麼？",
        content: [
          "##“當一方主觀感受到自己受傷了，就可以被定義為霸凌。”",
          "「若你在人際關係中，有被冷落、貶低或不被認同的感覺，這時的你可能就正處在霸凌中。」蘇心理師認為，即使霸凌者表示自己不是故意或是無意的，被霸凌者皆不需自我懷疑，人際互動的宗旨即是互相磨合，面對與他人的差異，人人都需要不斷的調整自己，時時反思是否有任何行為造成彼此的身心受損。",
        ],
      },
      {
        title: "正視霸凌陰影的重要",
        content: [
          "##“人感知最大的壓力來源，就是來自他人的眼光。”",
          "「正視霸凌陰影是絕對必要的。」蘇心理師有感地說。科學顯示，當人類感受到被群體排擠和不喜歡時，大腦會自動記下這個「痛」的感覺。若選擇不去面對，不管那個排擠多小，我們都會留下一種接近死亡的感覺，導致日後永遠覺得自己不如人，永遠覺得自己無法交到好朋友。",
          "##“若選擇逃避陰影，那在未來的所有關係中，我們都會帶著這樣不客觀的陰影濾鏡去看所有人。”",
          "「就算身邊的人只是因忙碌而無暇回應，我們都會主觀判斷一定是我不夠好，所以他不喜歡我，到時候他一定會離開我！」蘇心理師心有戚戚地說。另外，她也特別強調，這樣的不信任感會一直存在，不定期流竄於被霸凌者日後的各種人際關係，造成被霸凌者對生活時時充滿不安全感。",
        ],
      },
      {
        title: "被霸凌者如何接納自我，重建對人群的信任？",
        content: [
          "說到如何揮別霸凌陰影，蘇心理師建議，給自己一個機會重新看待這件事情吧。大家可以簡單布置回憶中過去的場景，拿一些抱枕或人偶讓自己去扮演一個客觀的第三者，摸摸自己的心，看見曾經無助的自己和霸凌者，有什麼新的感受？",
          "##“若我們能學習跳脫當時的自己，我們就不會誤以為自己永遠弱小、無能為力。”",
          "「小學三年級時，我被班上同學集體排擠」，蘇心理師向我們傾吐曾經的經歷，「這層霸凌陰影曾打亂我的生活」她苦笑，之後，她慢慢練習以第三人稱觀看過去，才忽然明白，當時的孤立無援是因為霸凌者知道身為轉學生，沒有友情連結的她是容易欺負的。接著告訴現在的自己，「我早已抽離那個不安全的環境，是時候該換副客觀的濾鏡了！」也就是說，若我們能學習適時拉開時空的距離，安全感就會被慢慢的紮根下來，對人群恢復信任！",
          "聽完蘇心理師對自身經歷的描繪後，曾經的迷茫隨著時間的流逝，在昔日和今日的邊界中重生。走出陰影，嶄新的樂章緩緩奏起，身為曾經的被霸凌者，蘇心理師以專業的角度告訴我們，在被霸凌者走出陰霾的過程中，外界能如何伸出援手？",
        ],
      },
      {
        title: "如何幫助受霸凌陰影所苦的朋友走出困境？",
        content: [
          "##“當你看見他的亮點，他就會生出更多的力量感；可是當你看見他做不好的部分，他就會生出更多的挫折感！”",
          "身為被霸凌者的朋友，如何以不刺傷的方式助他們掃除陰霾呢？「學習不評價吧！」蘇心理師微笑地表示。若我們能帶著好奇去了解他做選擇的原因，尊重每個人都有自己專屬的時間線去解決人生中面臨的困難，接受他暫時無法脫繭而出，培養耐心跟對被霸凌者的信任，甚至幫他看見他的力量所在，試著去鼓勵他已成長的部分！",
          "看見我們仍有些疑惑，她微微一笑後，進一步舉例：假設面對霸凌者的挑釁，以前被霸凌者的第一反應，是不顧自己是否與周圍有情感連結，立即罵回去；但，現在的他會選擇先冷靜分析情勢，這就表示他已經學習到不會引發更多衝突的處事方式！這時，身為朋友的我們應該立刻以鼓勵替代責罵，肯定他已學會認真保護自己，讓他看見自己的正面價值。",
        ],
      },
      {
        title: "旁觀者如何抵擋壓力，為被霸凌者挺身而出？",
        content: [
          "##“被霸凌者真正渴望的，是旁人的了解與陪伴。”",
          "「若旁觀者畏懼挺身而出讓自己陷入霸凌的循環，那就給予被霸凌者真誠且溫暖的傾聽吧！」蘇心理師真誠地呼籲。與其爭論誰應該救誰的責任歸屬，正視我們每一個人都有歧視的陰暗面才是首要之務！當我們越有意識且真實面對自己這個部分，它反而不會變成一個外化的行動去傷害別人，讓霸凌不再無限循環，旁觀者亦能成為終止霸凌中的一環。",
        ],
      },
      {
        title: "如何扭轉社會對被霸凌者的負面標籤？",
        content: [
          "##“我們的社會最需要增進的一個概念，就是察覺自己有責怪受害者的傾向。”",
          "首先蘇心理師強調，「責怪受害者」看似罪大惡極，其實是衍生於生理上的正常機制。在我們看見他人受欺負時，因為畏懼有一天也會發生在自己身上，所以我們會立刻告訴自己，應該盡快把被欺負者切割出去，以此表示這個受害者跟我不一樣，為自己塑造安全感。「簡短地說，我們是用譴責受害者來得到心安。」蘇心理師感嘆地說。",
          "「先從學習不評價彼此開始」，蘇心理師自信地說道，若我們不去創造任何人較優越的競爭比較，而是開始創造一個合作的狀態，如此，每一個人都能獲得真正的自信，深信自己的價值一直都是圓滿的，在營造你我的心靈安適中終止霸凌。",
          "##心中的安全感是奠基於內在而不是外界的權力位階，真正的自信不是自我感覺良好，而是當我感覺不好我依然完整！祝福大家都可以找到內在本有的完整感！",
        ],
      },
    ],
    video: {
      title: "訪談影片",
      src: "https://www.youtube.com/embed/FmEA9GTX9l8",
    },
  },
  {
    basic: {
      path: "6th-tedview-design",
      title: "Design the way you are",
      date: "Dec 5, 2022",
      banner: "6th-design-banner.jpg",
      square: "6th-design-square.jpg",
      tag: "從台灣到美國求學，不一樣的環境讓 Serene 擁有許多精彩經歷。儘管在選擇中跌跌撞撞，Serene 依然踏著自信優雅的步伐，繼續當個摯愛世界的人...",
      type: "view",
    },
    section: [
      {
        title: "",
        content: [
          "從台灣到美國求學，不一樣的環境讓 Serene 擁有許多精彩經歷。儘管在選擇中跌跌撞撞，Serene 依然踏著自信優雅的步伐，繼續當個摯愛世界的人。",
          "冬季涼爽的午後，一個女孩衣著優雅，款款落座。她是 Serene，自北一女中畢業後前往美國 Duke University 留學的期間，主修生物的她走遍世界各地，完成多個研究之旅，並累積了豐富的生物領域經驗。特別的是，Serene 曾在大一升大二的暑假，跟著學校的計畫去到紐約，成為時尚造型師的實習生。這次跨領域的嘗試帶給 Serene 許多不一樣的想法和改變，也讓她在大二的時候開展了自己的 Youtube 頻道，分享她在美國的大學生活以及和時尚、美妝相關的內容。",
        ],
      },
      {
        title: "遠渡美國求學，初期卻遭遇挫敗",
        content: [
          "「一開始會被出國留學吸引是因為國外不用選主修。」說起美國留學的經驗，Serene 侃侃而談，「我想要好好利用每個機會去探索每一個不同領域，而不是只把生物主修讀完就好。」在美國的日子中，Serene參加了許多研究計畫和活動，充分的運用學校的資源，跳出舊有的觀念，將留學的價值最大化。",
          "「但是如果要說在美國讀書遇到最大的困難的話，應該是一開始的適應期吧！」當時初到美國的她，不可避免的和美國有一段磨合的過程。在台灣的時候，Serene 覺得自己在大家的眼中有一個既定的印象，即便自己遭遇了一些失敗，那些既定的、好的印象依舊存在。然而，到了美國後，這個印象消失了，一切都要從零開始。Serene 和我們分享了她修大一微積分課的故事，當時這門課有一份分組作業，其中老師出了一道較難的題目，在大家都卡關的時候，Serene 分享了自己的解法，卻受到同學們的質疑，儘管只是一件小小的事，但也讓 Serene 受到了一點衝擊，也因為這次的經驗，讓她覺得自己需要付出更多的努力來證明自己的能力。",
        ],
      },
      {
        title: "客觀分析降低後悔，Serene流的「選擇哲學」",
        content: [
          "求學的日子本來就不是一帆風順的，談到如何做選擇，Serene 也提出了一套自己的見解，「我會先列出每個選項的優缺點去比較，當然也要同時考慮現實的因素。」",
          "在大三那年，Serene 迎來了大學四年中最重大的選擇。當時 Serene 規劃大四的兩個學期分別要去日內瓦的WHO上課與實習，以及到摩洛哥參加一個結合社會議題與媒體的專案。在申請書都準備好的情況下，Serene 收到她所在的海洋實驗室和學校癌症研究中心合作、為期一年半的研究計畫邀請。這讓她非常猶豫，是否仍要依照原本排定的計畫還是應該繼續留在研究室。「我最後選擇留下。」Serene 平靜地說，「因為我覺得這麼難得的研究機會以後不會再碰到，雖然我也想要嘗試 NGO 的工作、摩洛哥的計畫也很有意義，但這些在我畢業之後都可以做，也有其他的替代方案，考量到我未來想要走研究相關的現實因素，我還是選擇留在研究室。」",
          "客觀的去分析每個選項，不僅大大降低了自己後悔的風險，也可以更堅定的走好每一步，這就是Serene的「選擇哲學」。",
        ],
      },
      {
        title: "從生物到時尚，在紐約時尚產業實習的日子",
        content: [
          "生物主修和時尚產業，聽起來是完全不同的兩個領域，「其實從過程中我發現，雖然表面上看起來很不一樣，當然專業知識不一樣，但很多以前學的技巧也可以用上，像是時間管理、效率、跟上司的應對進退等等。」",
          "去到紐約後，Serene 很幸運可以跟著一個大造型師工作，但在快速的時尚產業中，非藝術相關科系出身的她在和其他實習生比較之下，顯得太「慢」了，Serene 也因此感到挫折，「有時候上司也知道慢了不是我的錯，但他還是要讓整個工作的過程可以順利進行，一開始我很不能理解，為什麼我要被不是我的問題責怪。」",
          "從 Serene 在 Dcard 上發表的一系列「紐約時尚實習日誌」中不難發現，在時尚產業工作是非常緊繃的，一分一秒都不能浪費，因此下班後往往會有鬆一口氣的感覺，但這樣的經驗當然也帶給 Serene 成長。",
          "「經歷過那次的實習，我不會想在時尚產業工作，這和我想像的太不一樣了！」雖然往後不會往這條路發展，但 Serene 並不認為自己浪費了那次實習的經驗，「就算沒有進一步的收穫，但至少劃掉了我人生清單上一個想去嘗試的選項，而且也培養出我很好的辦事能力，在實驗室的時候手腳也變得俐落。」Serene 肯定每次經驗，因為每個嘗試都彌足珍貴。",
        ],
      },
      {
        title: "22歲的徬徨與迷惘",
        content: [
          "儘管 Serene 的經歷看起來豐富精彩，但在光鮮亮麗的外表下，隱藏著和所有人一樣的迷惘和害怕，「我不覺得我有真正走出迷惘過耶，因為每一個選擇往往會伴隨著新的迷惘。」Serene 不諱言地告訴我們，在美國大學生活即將告一段落的時候，她也不是很確定自己未來的職業方向，「原本的路很明確，就是想要走生物研究相關，但當我開始經營 YouTube 頻道後，我也不是很確定自己到底想要做什麼。」",
          "於是，Serene 給了自己半年的時間回台灣，拍自己想拍的影片。但她也坦言，就算做出了這個決定也還是會徬徨，因為她也無法預知這半年會發生什麼事，「如果生活中有很多未知的話，我也只能抓住自己已知的東西，並不奢望解決自己無法解決的事。」面對未來的不確定性，Serene 覺得首先要做好自己份內的事，其餘的就慢慢地一邊嘗試、一邊修正。",
          "「如果壓力很大的話，就先好好跟自己溝通吧！」問問自己到底擔心的事是什麼、壓力的根源是什麼，「不然也可以去看一些心靈雞湯的電影！」想了想，Serene 笑著給了一個可愛的答案。",
        ],
      },
      {
        title: "沒有一個選擇足以決定你的一生",
        content: [
          "最後我們和 Serene 談及大學科系與就職選擇，面對很多大學生不確定讀哪個科系以及未來出路的問題，Serene 建議可以請教各科系的學長姐，請他們分享在各科系讀書的心得以及對他現在就業的實質幫助。「當然也要多方嘗試，而且嘗試過後要去分析心得，像是我會分析時尚產業我不喜歡的點是什麼、仍然喜歡的點是什麼，這樣才比較知道什麼是自己想要的。」",
          "Serene 也說，一開始她覺得生態是生物領域最無趣的部分，但她在參加了哥斯大黎加的生態相關研究計畫後，發覺生態其實比她想得還有趣，也因此認識了在海洋實驗室的朋友，海洋生物之後也變成她的一項專業。",
          "「不要太快去否決某件事，一小步嘗試都可能帶來不錯的後果。」Serene堅定的說，「而且我相信，沒有一個選擇會毀滅或者完全決定你的一生。」",
          "##人生是種選擇，我們還這麼年輕，我們還可以做任何事，我們還可以改變心意，我們還可以重新來過。",
        ],
      },
    ],
    video: {
      title: "訪談影片",
      src: "https://www.youtube.com/embed/4VXkMZwfcwo",
    },
  },
];
